import styled from 'styled-components/macro';
import { COLORS, TYPOGRAPHY } from 'styleguide';
import Content from 'components/ConfirmModal/Content';

const SmallFormTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 5px;
  margin: 8px 0 24px;
  ${TYPOGRAPHY.name}
  color: #fff;
  border: 1px solid ${COLORS.line};
  border-radius: 4px;
  background-color: transparent;
  outline: none;
  resize: none;

  &::placeholder {
    color: ${COLORS.gray40};
  }

  ${/* sc-sel */Content} & {
    border-color: ${COLORS.gray20};
  }
`;

export default SmallFormTextarea;
